"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateLocale = void 0;
const Locales = __importStar(require("date-fns/locale"));
const convertToCodes = (locale = '') => {
    const [langCode, localCode] = locale.split('-');
    return ({
        localeCode: localCode ? `${langCode}${localCode.toUpperCase()}` : langCode,
        languageCode: langCode,
    });
};
const getDateLocale = (locale) => {
    var _a, _b;
    const { localeCode, languageCode } = convertToCodes(locale);
    return ((_b = (_a = Locales[localeCode]) !== null && _a !== void 0 ? _a : Locales[languageCode]) !== null && _b !== void 0 ? _b : Locales.enGB);
};
exports.getDateLocale = getDateLocale;
//# sourceMappingURL=date-locale.js.map